import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useBilling } from "../hooks/useBilling";
import { SpinnerIcon, CheckCircleIcon, AlertCircleIcon } from "../Icons";

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { capturePayment } = useBilling();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("Verifying your payment...");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processPayment = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setMessage("Invalid payment parameters");
        setTimeout(() => navigate("/manage-subscriptions/payment-history"), 3000);
        return;
      }

      const result = await capturePayment(token);

      if (result.success) {
        setStatus("success");
        setMessage("Payment completed successfully!");
      } else {
        setStatus("error");
        setMessage(result.message || "Payment capture failed");
      }

      setTimeout(() => navigate("/manage-subscriptions/payment-history"), 3000);
    };

    processPayment();
  }, [searchParams, capturePayment, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8 max-w-md w-full text-center">
        {status === "processing" && (
          <>
            <SpinnerIcon className="text-blue-600 text-6xl mx-auto mb-4 animate-spin" />
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Processing Payment
            </h2>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircleIcon
              size={64}
              className="text-green-600 mx-auto mb-4"
            />
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Payment Successful!
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">Redirecting to payment history...</p>
          </>
        )}

        {status === "error" && (
          <>
            <AlertCircleIcon size={64} className="text-red-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Payment Failed
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">Redirecting to payment history...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;